import * as React from 'react'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import axios from 'axios'

import './../styles/auth/auth.css'
import logo from './../images/logo.png'
import {Button, TYPES} from './../components/shared/button'

class PasswordReset extends React.Component {
  constructor() {
    super()

    this.state={
      password: '',
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault()
    axios.post(
      '/rest-auth/password/reset/',
      {
        email: this.state.email,
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    ).then(response => {
      this.toast()
    }).catch(error => {
          toastr.error('Error', "Couldn't send email. Please try again")
        })
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value.toLowerCase() });
  }

  toast = () => {
    toastr.removeByType('error')
    toastr.success('Success', 'Password Email Sent')
    this.props.history.push(`/`)
  }

  authForm = () => {
    return (
        <div className='auth-box'>
        <img src={logo} alt='BayWatch Technologies' />
          <form onSubmit={this.handleSubmit} >
            <input type='email' placeholder='Email' name='email' onChange={this.handleChange} className='auth-input'/>
            <div className='auth-button-container'>
              <Button
                text='Request Password'
                type='logIn'
                buttonType={TYPES.SUBMIT}
              />
            </div>
          </form>
        </div>
    )
  }

  render () {
    return (
      <div className='auth-container'>
       {this.authForm()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect( mapStateToProps )( PasswordReset )



// WEBPACK FOOTER //
// ./src/pages/passwordReset.js